<template>
  <DropdownSelectorWrapper :test-id-prefix="testIdPrefix">
    <div class="dropdown-column" :data-testid="`${testIdPrefix}-column-left`">
      <DropdownSelectorItem
        v-for="(item, index) in leftColumnItems"
        :key="index"
        :icon="item.icon"
        :label="item.label"
        :value="item.value"
        :selected="item.value === context._value"
        :data-testid="`${testIdPrefix}-item-${item.value}`"
        @select="handleSelect"
      />
    </div>
    <div class="dropdown-column" :data-testid="`${testIdPrefix}-column-right`">
      <DropdownSelectorItem
        v-for="(item, index) in rightColumnItems"
        :key="index"
        :icon="item.icon"
        :label="item.label"
        :value="item.value"
        :selected="item.value === context._value"
        :data-testid="`${testIdPrefix}-item-${item.value}`"
        @select="handleSelect"
      />
    </div>
  </DropdownSelectorWrapper>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { FormKitFrameworkContext } from '@formkit/core';
import DropdownSelectorWrapper from './DropdownSelectorWrapper.vue';
import DropdownSelectorItem from './DropdownSelectorItem.vue';

export interface DropdownItem {
  icon: string;
  label: string;
  value: string;
}

interface Props {
  context: FormKitFrameworkContext;
  testIdPrefix?: string;
}

const props = withDefaults(defineProps<Props>(), {
  testIdPrefix: 'dropdown-selector',
});

// Get items from context (passed via FormKit options attribute)
const items = computed<DropdownItem[]>(() => {
  // FormKit passes custom props directly on the context object
  return props.context.attrs.options || [];
});

// Split items into two columns
const leftColumnItems = computed(() => {
  const half = Math.ceil(items.value.length / 2);
  return items.value.slice(0, half);
});

const rightColumnItems = computed(() => {
  const half = Math.ceil(items.value.length / 2);
  return items.value.slice(half);
});

const handleSelect = (value: string) => {
  // Update FormKit value
  props.context.node.input(value);
};
</script>

<style scoped>
.dropdown-column {
  @apply rounded-10 flex flex-col items-start p-2.5 gap-2.5 flex-1;
}
</style>